module.exports = __webpack_public_path__ + "img/dc4c6d99521ed581c30c794670d88d0a.png";